import type { CustomerStore, CustomerKidDiscipline } from './interfaces'

export const getters = {
  getCustomer: (state: CustomerStore): CustomerStore['customer'] => state.customer,
  hasCustomer: (state: CustomerStore): boolean => !!state.customer,
  getCustomerKidDisciplines: (state: CustomerStore): CustomerKidDiscipline[] => {
    if (!state.customer) return []

    return state.customer.kids.flatMap(kid =>
      kid.disciplines.map(discipline => ({
        id: discipline.id,
        code: discipline.code,
        kidId: kid.id,
        kidName: kid.name,
      })),
    )
  },
  getDetails: (state: CustomerStore): CustomerStore['details'] => state.details,
  hasDetails: (state: CustomerStore): boolean => !!state.details,
  getForm: (state: CustomerStore): CustomerStore['form'] => state.form,
  isProcessing: (state: CustomerStore): boolean => state.processing > 0,
  isModalDelete: (state: CustomerStore): CustomerStore['modalDelete'] => state.modalDelete,
  isModalKidCreate: (state: CustomerStore): CustomerStore['modalKidCreate'] => state.modalKidCreate,
}
